var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.team)?_c('team-form',{attrs:{"team":_vm.team}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }